// extracted by mini-css-extract-plugin
var _1 = "modal_bg__qa9ah";
var _2 = "#4c4c4c";
var _3 = "modal_button__ffrrp";
var _4 = "modal_buttonwrapper__ewnc5";
var _5 = "modal_close__nnot4";
var _6 = "modal_content__ybmff";
var _7 = "modal_contentwrapper__ajmox";
var _8 = "640px";
var _9 = "790px";
var _a = "#057676";
var _b = "modal_header__uog9v";
var _c = "modal_headerwrapper__rg0hz";
var _d = "#434343";
var _e = ".88";
var _f = "modal_innercontent__-tsqq";
var _10 = "79px";
var _11 = "110px";
var _12 = "72px";
var _13 = "665px";
var _14 = "modal_scrollwrapper__mmjm3";
var _15 = "teal";
var _16 = "2";
var _17 = "#cdd3dc";
var _18 = "modal_wrapper__be2ua";
export { _1 as "bg", _2 as "body", _3 as "button", _4 as "buttonWrapper", _5 as "close", _6 as "content", _7 as "contentWrapper", _8 as "controlsMobileWidth", _9 as "controlsStackedWidth", _a as "darkTeal", _b as "header", _c as "headerWrapper", _d as "headline", _e as "initialScale", _f as "innerContent", _10 as "menuHeight", _11 as "menuHeightLarge", _12 as "menuHeightMobile", _13 as "modalMobileWidth", _14 as "scrollWrapper", _15 as "teal", _16 as "timelineStrokeWidth", _17 as "timelineTrackColor", _18 as "wrapper" }
